import { render, staticRenderFns } from "./evaluar_coordinador.vue?vue&type=template&id=52f5c43f"
import script from "./evaluar_coordinador.vue?vue&type=script&lang=js"
export * from "./evaluar_coordinador.vue?vue&type=script&lang=js"
import style0 from "./evaluar_coordinador.vue?vue&type=style&index=0&id=52f5c43f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports